import { defineComponent as d, computed as o, openBlock as s, createElementBlock as a, createElementVNode as t, toDisplayString as n, createCommentVNode as h, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "62a5fb56-dece-4754-9dc9-7cd39fcb6868" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), g = { mask: "url(#62a5fb56-dece-4754-9dc9-7cd39fcb6868)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#333" d="m0 144.7 257-22.4 255 22.4v222.6l-254.9 31L0 367.3z"></path><path fill="#d80027" d="M0 0h512v144.7H0z"></path><path fill="#496e2d" d="M0 367.3h512V512H0z"></path><g fill="#eee"><path d="m315.6 209.3 21 29 34-11-21 29 21 28.8-34-11-21 29v-36l-34-11 34-11z"></path><path d="M258.3 328.4a72.3 72.3 0 1 1 34.4-136 89 89 0 1 0 0 127.3 72 72 0 0 1-34.4 8.7z"></path></g>', 4), v = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ d({
  __name: "ly",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), c = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (s(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", g, [
        e.flagName ? (s(), a("title", k, n(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  N as default
};
//# sourceMappingURL=ly-0afbb19a.js.map
